import * as React from "react";
import { Dictionary } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { Button } from "../../../../../../../../react-core/Html/Button";
import TableFilterDropdown from "../../../../../../../../react-core/Html/Components/TableFilterDropdown";
import { Div } from "../../../../../../../../react-core/Html/Div";
import { Guid } from "../../../../../../../../react-core/Utils/Guid";
import { AdviserSiteTagManagerEvent } from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { DocumentTypeOptionGroups } from "../Resource/Constant";

interface IDocumentsFilterProps {
    type: Array<Dictionary>;
    handleFilterChange: (val) => void;
    event?: AdviserSiteTagManagerEvent;
}

interface IDocumentsFilterState {
    documentType: Array<Dictionary>;
    toggleFilter: any;
    isSelected: boolean;
}

export class DocumentsFilters extends React.Component<IDocumentsFilterProps, IDocumentsFilterState> {
    constructor(props: IDocumentsFilterProps) {
        super(props);
        this.state = {
            documentType: this.initialDocumentType(),
            toggleFilter: new Object(),
            isSelected: true,
        };
    }

    private initialDocumentType() {
        const type = this.props.type.concat();
        if (type.filter((o) => o.key == "0").length > 0) {
            const optionList = [];
            DocumentTypeOptionGroups.forEach((dict: Dictionary, index) => {
                dict.value.map((item: Dictionary, i) => {
                    optionList.push(item);
                });
            });
            optionList.push({ key: "0", value: "All" });
            return optionList;
        }
        return type;
    }

    public render(): JSX.Element {
        const { handleFilterChange } = this.props;
        const { documentType, isSelected } = this.state;
        return (
            <TableFilterDropdown
                cssWrapper="table-default-filter is-wide"
                title="Filter documents"
                onOpen={(e) => this.setState({ toggleFilter: e })}
                event={this.props.event}
            >
                <div>
                    {this.renderDropdownContent(this.props)}
                    <div className="row row-right narrow-gutter pt-24">
                        <div className="col-auto col-middle">
                            {isSelected ? (
                                <Button className="hyperlink" onClick={() => this.deselectAll()}>
                                    Deselect all
                                </Button>
                            ) : (
                                "Deselect all"
                            )}
                        </div>
                        <div
                            className="col-auto col-middle"
                            onClick={() => {
                                this.state.toggleFilter(true);
                                this.setState({ documentType: [{ key: "0", value: "All" }] }, () => {
                                    handleFilterChange(this.state.documentType);
                                });
                            }}
                        >
                            <button className="btn secondary block-xxs">Cancel</button>
                        </div>
                        <div
                            className="col-auto col-middle"
                            onClick={() => {
                                this.state.toggleFilter(true);
                                handleFilterChange(documentType);
                            }}
                        >
                            <button className="btn primary block-xxs">Apply</button>
                        </div>
                    </div>
                </div>
            </TableFilterDropdown>
        );
    }

    private renderDropdownContent(props: IDocumentsFilterProps) {
        const { documentType } = this.state;
        const isChecked = documentType.filter((o) => o.key == "0").length > 0;
        return (
            <Div className="document-dropdown-list" data-dropdown-menu-row="" aria-labelledby="document-type-selector">
                <div className="line">
                    {/* <h3 className="text-size-16 color-4 mb-10 text-bold">Select documents to view</h3> */}
                    <div className="form-group square-checkbox mb-18">
                        <label htmlFor="0" className="controls-checkbox">
                            <input
                                id="0"
                                name="SelectDocument"
                                checked={isChecked}
                                onChange={(e: any) => {
                                    const optionList = [];
                                    if (e.target.checked) {
                                        DocumentTypeOptionGroups.forEach((dict: Dictionary, index) => {
                                            dict.value.map((item: Dictionary, i) => {
                                                optionList.push(item);
                                            });
                                        });
                                        optionList.push({ key: "0", value: "All" });
                                    }
                                    this.setState({
                                        documentType: optionList,
                                        isSelected: optionList.filter((o) => o.key == "0").length > 0,
                                    });
                                }}
                                type="checkbox"
                                value="true"
                            />
                            <span aria-hidden={true} className="gfx" />
                            <span className="label">All documents</span>
                        </label>
                    </div>
                    <hr className="mt-0 mb-0"></hr>
                    <div className="row narrow-gutter">
                        {this.renderOptionRow1(props)}
                        {this.renderOptionRow2(props)}
                        {this.renderOptionRow3(props)}
                    </div>
                </div>
            </Div>
        );
    }

    private renderOptionRow1(props: IDocumentsFilterProps) {
        return (
            <div className="col-12 col-sm-4 col-lg-3">
                <h2 className="h5 mt-24">Tax certificates</h2>
                {this.renderOptionGroup("Tax certificates", props)}
                <h2 className="h5 mt-24">Documents</h2>
                {this.renderOptionGroup("Documents", props)}
                <h2 className="h5 mt-24">Reports</h2>
                {this.renderOptionGroup("Reports", props)}
                <h2 className="h5 mt-24">Quotes</h2>
                {this.renderOptionGroup("Quotes", props)}
            </div>
        );
    }

    private renderOptionRow2(props: IDocumentsFilterProps) {
        return (
            <div className="col-12 col-sm-4 col-lg-3">
                <h2 className="h5 mt-24">Product key information</h2>
                {this.renderOptionGroup("Product key information", props)}
                <h2 className="h5 mt-24">Trading notifications</h2>
                {this.renderOptionGroup("Trading notifications", props)}
                <h2 className="h5 mt-24">Forms</h2>
                {this.renderOptionGroup("Forms", props)}
                <h2 className="h5 mt-24">Other</h2>
                {this.renderOptionGroup("Other", props)}
            </div>
        );
    }

    private renderOptionRow3(props: IDocumentsFilterProps) {
        return (
            <div className="col-12 col-sm-4 col-lg-6">
                <h2 className="h5 mt-24">Investment key information</h2>
                {this.renderOptionGroup("Investment key information", props)}
            </div>
        );
    }

    private renderOptionGroup(key, props: IDocumentsFilterProps) {
        const { documentType } = this.state;
        const option = DocumentTypeOptionGroups.filter((x) => x.key === key);
        const type = documentType.concat();
        if (option && option.length > 0) {
            return (
                <div>
                    {option[0].value.map((i) => {
                        const isChecked = documentType && documentType.filter((o) => o.key === i.key).length > 0;
                        const isCheckedAll = documentType.filter((o) => o.key == "0").length > 0;
                        return (
                            <>
                                <div key={i.key + Guid.getNext()} className="form-group square-checkbox mb-4">
                                    <label htmlFor={i.key} className="controls-checkbox">
                                        <input
                                            id={i.key}
                                            name="SelectDocument"
                                            type="checkbox"
                                            value="true"
                                            checked={isChecked || isCheckedAll}
                                            onChange={(e: any) => {
                                                const selectedList = [];
                                                let operationList = [];
                                                if (e.target.checked) {
                                                    type.push(i);
                                                    DocumentTypeOptionGroups.forEach((dict: Dictionary, index) => {
                                                        dict.value.map((item: Dictionary, i) => {
                                                            selectedList.push(item);
                                                        });
                                                    });
                                                    if (selectedList.length == type.length) {
                                                        type.push({ key: "0", value: "All" });
                                                    }
                                                    operationList = type;
                                                } else {
                                                    operationList = type.filter(
                                                        (value, index, arr) => value.key !== i.key && value.key !== "0"
                                                    );
                                                }

                                                this.setState({
                                                    documentType: operationList,
                                                    isSelected: operationList.length > 0,
                                                });
                                            }}
                                        />
                                        <span aria-hidden={true} className="gfx" />
                                        <span className="label">{i.value}</span>
                                    </label>
                                </div>
                                <br />
                            </>
                        );
                    })}
                </div>
            );
        }
    }

    private deselectAll() {
        const { documentType, isSelected } = this.state;
        const optionList = [];
        const type = documentType.concat();
        DocumentTypeOptionGroups.forEach((dict: Dictionary, index) => {
            dict.value.map((item: Dictionary, i) => {
                optionList.push(item);
            });
        });
        const list = type.filter((o) => o.key != "0");

        if (type.length > 0) {
            this.setState({ documentType: [], isSelected: false });
        }
    }
}
